
import {Component, Vue, Prop, Emit} from 'vue-property-decorator';
import {FormModel} from 'ant-design-vue';
import moment, {Moment} from 'moment';
import {SectionToChinese, formatClasses} from './utils';
import {editScheduleRoutineSettingApi} from './api';
const ErrorType = {
    startEndError: '1',
    orderError: '2'
};
const DefaultTimes = [
    {
        startTime: null,
        endTime: null
    }
];
@Component
export default class SettingDialog extends Vue {
    @Prop({default: ''}) schoolId?: string;
    @Prop({default: () => []}) data:
        | {
              startTime: string | null;
              endTime: string | null;
          }[]
        | undefined;
    loading = false;
    form: {
        times: {
            startTime?: Moment | null;
            endTime?: Moment | null;
            isError?: false | string;
        }[];
    } = {
        times: []
    };
    hasEmpty = false;
    errorType = '';
    errorTip = '';
    isChange = false;
    originTimes = '';
    get okButtonProps() {
        return {props: {disabled: !!this.errorType || !this.isChange}};
    }

    created() {
        const data = this.data && this.data.length ? this.data : DefaultTimes;
        this.form.times = data.map((item: any) => ({
            startTime: item.startTime ? moment(item.startTime, 'HH:mm') : null,
            endTime: item.endTime ? moment(item.endTime, 'HH:mm') : null,
            isError: false
        }));
        this.originTimes = this.getTimesString();
    }

    getTimesString() {
        return this.form.times.reduce((result, item) => {
            if (item.startTime) {
                result += item.startTime?.format('HH:mm');
            }
            if (item.endTime) {
                result += item.endTime?.format('HH:mm');
            }
            return result;
        }, '');
    }

    sectionToChinese(val: number) {
        return SectionToChinese(val);
    }

    handleCreate() {
        this.form.times.push({
            startTime: undefined,
            endTime: undefined
        });
    }

    handleDelete() {
        const len = this.form.times.length;
        if (len === 1) return;
        this.form.times.splice(len - 1, 1);
        this.setIsChange();
    }

    changeTime(index: number) {
        const {times} = this.form;
        const len = times.length;
        times.forEach(item => {
            item.isError = false;
        });
        this.errorType = '';
        this.errorTip = '';
        // 自身开始结束判断
        if (
            times[index] &&
            times[index].startTime &&
            times[index].endTime &&
            !times[index].endTime?.second(0).isAfter((times[index].startTime as Moment).second(0))
        ) {
            times[index].isError = ErrorType.startEndError;
            this.errorType = ErrorType.startEndError;
            this.errorTip = '节的开始时间不能小于结束时间';
            return;
        }
        for (let i = 0; i < len - 1; i++) {
            const first = times[i];
            if (first.endTime) {
                for (let j = i + 1; j < len; j++) {
                    const second = times[j];
                    if (second.startTime && !first.endTime.second(0).isBefore(second.startTime.second(0))) {
                        first.isError = ErrorType.orderError;
                        second.isError = ErrorType.orderError;
                        if (!this.errorType) {
                            this.errorType = ErrorType.orderError;
                            this.errorTip = '节的开始时间需大于前面节点的结束时间';
                        }
                    }
                }
            }
        }
        this.setIsChange();
    }

    setIsChange() {
        this.isChange = this.getTimesString() !== this.originTimes;
        this.hasEmpty = false;
    }

    handleCancel() {
        this.$emit('closeModal');
    }
    handleOk() {
        let form = this.$refs.form as FormModel;
        this.hasEmpty = this.form.times.some(x => !x.startTime || !x.endTime);
        if (this.hasEmpty) return;
        this.loading = true;
        const data = {
            schoolId: this.schoolId,
            classes: this.form.times.map(item => {
                const [startHour, startMinute] = item.startTime?.format('HH:mm').split(':') || [];
                const [endHour, endMinute] = item.endTime?.format('HH:mm').split(':') || [];
                return {
                    startHour,
                    startMinute,
                    endHour,
                    endMinute
                };
            })
        };
        editScheduleRoutineSettingApi(data).then((res: any) => {
            if (res && res.data) {
                const classes = formatClasses(res.data.classes);
                this.$emit('update:data', classes);
                this.handleCancel();
                this.$message.success('操作成功');
                this.$emit('ok', classes);
            }
        });
    }
}
